import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import contentPl from './content_pl';
import contentEn from './content_en';
// TODO: https://stackoverflow.com/questions/48493960/using-google-map-in-react-component obczaić stylowanie
// https://developers.google.com/maps/documentation/javascript/styling#styled_map_wizard

const mapUrl = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyCxIJT0mlKQVPMofia8ToOWtmJKgrJM9KI&q=Szkola+Zlotnictwa+Xerion,Krakow+Polska';
const iframe = `<iframe frameborder="0" style="border:0" src="${mapUrl}" width="100%" height="100%"></iframe>`;

function Contact({ language }) {
  const content = language === 'english'
    ? contentEn
    : contentPl;
  return (
    <Grid container>
      <Grid item className="leftColumn" xs={12} sm={6} md={5}>
        {/* eslint-disable-next-line react/no-danger */}
        <div style={{ height: '100%', minHeight: 400, paddingRight: 16 }} dangerouslySetInnerHTML={{ __html: iframe }} />
      </Grid>
      <Grid item className="rightColumn" xs={12} sm={6} md={7}>
        <div className="onePixWrapper">
          <Grid
            item
            className="onePixChild"
            style={{ padding: 40 }}
          >
            <Typography variant="h5">
              {content.description.label}
            </Typography>
            <Typography variant="body2">
              {content.description.value}
            </Typography>
          </Grid>
          <Grid
            item
            className="onePixChild"
            style={{ padding: 40 }}
          >
            <Typography variant="h5">
              {content.email.label}
            </Typography>
            <Typography variant="body2">
              {content.email.value}
            </Typography>
          </Grid>
          <Grid
            item
            className="onePixChild"
            style={{ padding: 40 }}
          >
            <Typography variant="h5">
              {content.address.label}
            </Typography>
            <Typography variant="body2">
              {content.address.value.map((x) => (
                <span>
                  {x}
                  {' '}
                  <br />
                </span>
              ))}
            </Typography>
          </Grid>

          <Grid
            item
            className="onePixChild"
            style={{ padding: 40 }}
          >
            <Typography variant="h5">
              {content.nip.label}
            </Typography>
            <Typography variant="body2">
              {content.nip.value}
            </Typography>

            <Typography variant="h5">
              <br />
              {content.bankAccount.label}
            </Typography>
            <Typography variant="body2">
              {content.bankAccount.value}
            </Typography>
          </Grid>

        </div>
      </Grid>
    </Grid>
  );
}

Contact.propTypes = {
  language: PropTypes.string,
};

Contact.defaultProps = {
  language: 'polish',
};

export default Contact;
